import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="credit-package"
export default class extends Controller {
  static targets = ["button", "creditAmount", "price", "hiddenAmount", "hiddenPackageId", "oauthForm"]

  connect() {
    const defaultButton = this.buttonTargets.find(button => button.dataset.default === "true") ||
      this.buttonTargets.find(button => parseInt(button.dataset.amount, 10) === 25) ||
      this.buttonTargets[0]

    if (defaultButton) {
      this.selectPackage({ target: defaultButton })
    }
  }

  selectPackage(event) {
    const button = event.target.closest("[data-credit-package-target='button']")
    if (!button) return

    const amount = parseInt(button.dataset.amount, 10)
    const credits = parseInt(button.dataset.credits, 10)

    this.buttonTargets.forEach(btn => {
      btn.classList.remove("bg-[#6C2BD9]", "scale-105", "ring-2", "selected")
      btn.classList.add("bg-gray-800/50")
    })

    button.classList.remove("bg-gray-800/50")
    button.classList.add("bg-[#6C2BD9]", "scale-105", "ring-2", "selected")

    this.creditAmountTarget.textContent = credits
    this.priceTarget.textContent = amount
    
    // Only update hidden field if it exists (user is signed in)
    if (this.hasHiddenAmountTarget) {
      this.hiddenAmountTarget.value = amount
    }

    if (this.hasHiddenPackageIdTarget) {
      this.hiddenPackageIdTarget.value = button.dataset.packageId
    }

    // The one-click Google buy posts to the OAuth path: OmniAuth only keeps the
    // query string (omniauth.params), so the chosen pack must live in the action.
    if (this.hasOauthFormTarget) {
      const url = new URL(this.oauthFormTarget.getAttribute("action"), window.location.origin)
      url.searchParams.set("credit_amount", amount)
      url.searchParams.set("package_id", button.dataset.packageId)
      this.oauthFormTarget.setAttribute("action", url.pathname + url.search)
    }
  }
}
